export function empty({routes}) {
  routes.push({
    path: "/",
    name: "LandingView",
    comLonent: () => import("@/views/LandingEmptyView.vue"),
  })
}
